export enum OneTrustConsentGroup {
  StrictlyNecessary = 'C0001',
  Analytical = 'C0002',
  Functional = 'C0003',
  Marketing = 'C0004',
}
